var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.217285 6.99426C0.217285 5.34854 1.45157 4.11426 3.09729 4.11426H13.383C14.9259 4.11426 16.263 5.34854 16.263 6.99426V13.1657C16.263 14.7085 15.0287 15.9428 13.383 15.9428H12.4573C12.0459 15.9428 11.6344 15.6343 11.6344 15.12C11.6344 14.7085 11.943 14.2971 12.4573 14.2971H13.383C14.103 14.2971 14.6173 13.68 14.6173 13.0628V6.8914C14.6173 6.1714 14.0001 5.65711 13.383 5.65711H3.09729C2.37729 5.65711 1.863 6.27426 1.863 6.8914V13.0628C1.863 13.7828 2.48014 14.2971 3.09729 14.2971H4.12586C4.53728 14.2971 4.94871 14.6057 4.94871 15.12C4.94871 15.5314 4.64014 15.9428 4.12586 15.9428H3.09729C1.55443 15.9428 0.217285 14.7085 0.217285 13.1657L0.217285 6.99426Z",
    fill: "#CEB96F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3318 5.96568C22.3318 5.75997 22.2289 5.45139 22.0232 5.34854C21.8175 5.14282 21.5089 5.14282 21.3032 5.14282L15.1318 7.19997C14.8232 7.30282 14.6175 7.61139 14.6175 7.91996V12.0343C14.6175 12.3428 14.8232 12.6514 15.1318 12.7543L21.3032 14.9143C21.5089 15.0171 21.8175 14.9142 22.0232 14.8114C22.2289 14.7085 22.3318 14.4 22.3318 14.1943V5.96568Z",
    fill: "#CEB96F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27394 4.93714C2.27394 2.16 4.43394 0 7.21108 0H13.8968C14.3082 0 14.6168 0.308571 14.6168 0.822857C14.6168 1.23429 14.3082 1.64571 13.7939 1.64571H7.21108C5.35966 1.54286 3.8168 3.08571 3.8168 4.93714H2.27394Z",
    fill: "#CEB96F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93178 10.7999C7.21178 10.7999 6.59464 11.2114 6.28607 11.9314C6.08035 12.3428 5.66893 12.5485 5.2575 12.3428C4.84607 12.1371 4.64035 11.7257 4.84607 11.3142C5.36035 10.0799 6.59464 9.25708 7.93178 9.25708C9.78321 9.25708 11.3261 10.7999 11.3261 12.5485C11.3261 14.0914 10.1946 15.4285 8.75464 15.8399V16.6628C8.75464 17.0742 8.44607 17.4857 7.93178 17.4857C7.52035 17.4857 7.10892 17.1771 7.10892 16.6628V15.1199C7.10892 14.7085 7.4175 14.2971 7.93178 14.2971C8.96035 14.2971 9.78321 13.4742 9.78321 12.5485C9.78321 11.6228 8.96035 10.7999 7.93178 10.7999Z",
    fill: "#CEB96F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0344 17.9998C8.44583 17.9998 8.85726 18.3083 8.85726 18.8226V19.3369C8.85726 19.7483 8.54869 20.1598 8.0344 20.1598C7.62298 20.1598 7.21155 19.8512 7.21155 19.3369V18.8226C7.3144 18.3083 7.62298 17.9998 8.0344 17.9998Z",
    fill: "#CEB96F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoH);
export default __webpack_public_path__ + "static/media/video-h.cfd9e2a6c06cceda23b500b8905c79c6.svg";
export { ForwardRef as ReactComponent };